import React from 'react';
import { SvgIcon } from '~/lib/bn-material-ui';

export function BarnIcon(props) {
  return (
    <SvgIcon viewBox='0 0 36 32' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.47369 16.9412L13.2631 9.41179L21.3157 5.17645H23.6841L31.7368 9.41179L35.9999 16.9412H35.9999V16.9413V32.0002H9.47363V16.9413V16.9412H9.47369ZM18 26.353H27.4737V32.0001H18V26.353ZM25.579 14.1174H19.8948V19.7646H25.579V14.1174Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2631 7.74062V6.58831V6.58808C13.263 2.94956 10.294 0 6.63157 0C2.96913 0 0.000122691 2.94956 0 6.58808V6.58831V32.0001H8.52612V16.0003V16.0001H8.52621L12.4509 8.16958L13.2631 7.74062Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
}
